export enum CandleType {
    Candle1 = 'candle-1',
    Candle2 = 'candle-2',
    Candle3 = 'candle-3',
    Candle4 = 'candle-4',
    Candle5 = 'candle-5',
}